import { Breadcrumbs, Content } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import { OptimizationProcessAside } from '../../components/OptimizationProcessAside/OptimizationProcessAside'
import { PageHeader } from '../../components/PageHeader/PageHeader'
import { vars } from '../../utils/appConfig'
import { locations } from '../../utils/locations'

interface RouteParams {
  optimizationProcessId: string
}

export const OptimizationProcessRoot = () => {
  const { t } = useTranslation()
  const { optimizationProcessId } = useParams<RouteParams>()

  return (
    <Content
      aside={<OptimizationProcessAside />}
      asideWidth={vars.asideWidth}
      breadcrumbs={
        <Breadcrumbs
          elements={[
            <Link to={locations.optimizationProcesses}>
              {t('Optimization processes')}
            </Link>,
            `#${optimizationProcessId}`,
          ]}
        />
      }
    >
      <PageHeader title={t('Sales Orders Lines')} />
    </Content>
  )
}
